import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  colspan: 1,
  style: {"width":"64px"}
}
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = {
  key: 0,
  colspan: 1
}
const _hoisted_4 = ["colspan"]
const _hoisted_5 = { style: {"white-space":"nowrap"} }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = {
  key: 0,
  class: "pl-2 pr-2 text-center"
}
const _hoisted_9 = { class: "px-0 text-center" }
const _hoisted_10 = { class: "pl-2 pr-2 text-left" }
const _hoisted_11 = { class: "text-left" }
const _hoisted_12 = { class: "px-0 text-right" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "pl-0 pr-2 text-right" }
const _hoisted_15 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_oss_filter_bar = _resolveComponent("oss-filter-bar")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_AccountingItemEdition2 = _resolveComponent("AccountingItemEdition2")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isAuthorized)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "my-3 justify-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "2",
                class: "pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_primary, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addItem(_ctx.accountingItems.length))),
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createTextVNode("Ajouter")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: _ctx.$vuetify.display.mobile ? '12' : '6',
                class: "pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_oss_filter_bar, {
                    type: _ctx.type,
                    "onUpdate:type": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.type) = $event)),
                    showTypeTag: false,
                    text: _ctx.search,
                    "onUpdate:text": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
                    startDate: _ctx.beginDate,
                    "onUpdate:startDate": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.beginDate) = $event)),
                    endDate: _ctx.endDate,
                    "onUpdate:endDate": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.endDate) = $event)),
                    minDate: _ctx.minDate,
                    maxDate: _ctx.maxDate,
                    showStatusTag: false,
                    statusIsManadatory: true,
                    dateIsManadatory: true,
                    thirdPartyCompanyName: _ctx.thirdPartyCompanyName,
                    "onUpdate:thirdPartyCompanyName": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.thirdPartyCompanyName) = $event)),
                    minPrice: _ctx.minAmount,
                    "onUpdate:minPrice": _cache[6] || (_cache[6] = 
                            ($event) => {
                                _ctx.documentType === 'PURCHASE_INVOICE'
                                    ? (_ctx.maxAmount = -$event + '')
                                    : (_ctx.minAmount = $event + '');
                            }
                        ),
                    maxPrice: _ctx.maxAmount,
                    "onUpdate:maxPrice": _cache[7] || (_cache[7] = 
                            ($event) => {
                                _ctx.documentType === 'PURCHASE_INVOICE'
                                    ? (_ctx.minAmount = -$event + '')
                                    : (_ctx.maxAmount = $event + '');
                            }
                        ),
                    "types-list": 
                            _ctx.logTypes.map((type) => {
                                return { value: type, text: _ctx.formatType(type) };
                            })
                        ,
                    "status-list": 
                            _ctx.allDocumentStatus.map((type) => {
                                return { value: type, text: _ctx.formatStatus(type) };
                            })
                        ,
                    companyId: _ctx.selectedCompany.id
                  }, null, 8, ["type", "text", "startDate", "endDate", "minDate", "maxDate", "thirdPartyCompanyName", "minPrice", "maxPrice", "types-list", "status-list", "companyId"])
                ]),
                _: 1
              }, 8, ["cols"]),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    outlined: "",
                    readonly: "",
                    "model-value": 'Debit : ' + _ctx.newCommonFormatCurrency(_ctx.totalDebit, undefined),
                    density: "compact"
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    outlined: "",
                    readonly: "",
                    "model-value": 'Crédit : ' + _ctx.newCommonFormatCurrency(_ctx.totalCredit, undefined),
                    density: "compact"
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.showQuickAccounting)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                class: "px-2 justify-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                      _createElementVNode("table", {
                        class: "oss-dense-table",
                        width: "100%"
                      }, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", {
                              class: "text-center",
                              width: "10%"
                            }),
                            _createElementVNode("th", {
                              class: "text-center",
                              width: "10%"
                            }, "Journal"),
                            _createElementVNode("th", {
                              class: "text-center",
                              width: "10%"
                            }, "Date"),
                            _createElementVNode("th", {
                              class: "text-acenter",
                              width: "10%"
                            }, "N° de pièce"),
                            _createElementVNode("th", {
                              class: "text-center",
                              width: "12%"
                            }, "Compte"),
                            _createElementVNode("th", {
                              class: "text-center",
                              width: "12%"
                            }, "Libellé"),
                            _createElementVNode("th", {
                              class: "text-center",
                              width: "12%"
                            }, "Débit"),
                            _createElementVNode("th", {
                              class: "text-center",
                              width: "12%"
                            }, "Crédit"),
                            _createElementVNode("th", {
                              class: "text-center",
                              width: "12%"
                            })
                          ])
                        ])
                      ], -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountingItems, (item, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (!_ctx.accountingItems[index].isRemoved)
                            ? (_openBlock(), _createBlock(_component_AccountingItemEdition2, {
                                key: index,
                                companyId: _ctx.selectedCompany.id,
                                onItemIsValid: 
                                (autocompletion, log, date) =>
                                    _ctx.makeItemValid(index, autocompletion, log, date)
                            ,
                                onItemIsNotValid: ($event: any) => (_ctx.makeItemInvalid(index)),
                                onAddItem: ($event: any) => (_ctx.addItem(index + 1)),
                                onRemoveItem: ($event: any) => (_ctx.removeItem(index)),
                                editionIndex: index,
                                defaultAutoCompletion: _ctx.accountingItems[index].autocompletion,
                                defaultLog: _ctx.accountingItems[index].log,
                                defaultDate: _ctx.accountingItems[index].date
                              }, null, 8, ["companyId", "onItemIsValid", "onItemIsNotValid", "onAddItem", "onRemoveItem", "editionIndex", "defaultAutoCompletion", "defaultLog", "defaultDate"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 256))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "auto" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_primary, {
                        onClick: _ctx.validateItems,
                        block: "",
                        disabled: _ctx.disableValidButton
                      }, {
                        default: _withCtx(() => _cache[15] || (_cache[15] = [
                          _createTextVNode("Valider")
                        ])),
                        _: 1
                      }, 8, ["onClick", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.documentType !== 'MAIL')
            ? (_openBlock(), _createBlock(_component_v_data_table_server, {
                key: 1,
                headers: _ctx.headers,
                items: _ctx.accountingLines,
                page: _ctx.pagination.page,
                "sort-by": _ctx.pagination.sortBy,
                "sort-desc": _ctx.pagination.descending,
                "items-per-page": _ctx.pagination.rowsPerPage,
                "items-length": _ctx.pagination.totalItems,
                "items-per-page-options": [5, 10, 25],
                loading: _ctx.loading,
                "hide-default-footer": "",
                "calculate-widths": "",
                "fixed-header": "",
                height: "80vh",
                class: "table",
                style: _normalizeStyle({
                    minWidth: '1150px',
                    marginTop: _ctx.showQuickAccounting && '30px',
                }),
                density: "compact"
              }, {
                headers: _withCtx(({ headers, columns }) => [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_1, [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_v_checkbox_btn, {
                          color: "primary",
                          "hide-details": "auto",
                          indeterminate: 
                                        _ctx.selectedALIds.length !== 0 &&
                                        _ctx.selectedALIds.length < _ctx.accountingLines.length
                                    ,
                          "model-value": 
                                        _ctx.accountingLines.length &&
                                        _ctx.selectedALIds.length === _ctx.accountingLines.length
                                    ,
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (
                                        _ctx.selectedALIds.length < _ctx.accountingLines.length
                                            ? (_ctx.selectedALIds = [
                                                  ..._ctx.accountingLines.map((x) => x.id),
                                              ])
                                            : (_ctx.selectedALIds = [])
                                    ))
                        }, null, 8, ["indeterminate", "model-value"])
                      ])
                    ]),
                    (_ctx.toRefresh)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_3, [
                          _createVNode(_component_v_icon, {
                            onClick: _ctx.refreshAccountingLines,
                            size: "small"
                          }, {
                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                              _createTextVNode("$fa-redo-alt")
                            ])),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("th", {
                      colspan: columns.length,
                      style: {"padding-left":"0"}
                    }, [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_col, { class: "d-flex justify-end align-center pb-1" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                modelValue: _ctx.sortBy,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.sortBy) = $event)),
                                items: _ctx.sortByList,
                                style: {"font-size":"0.75rem","width":"min-content"},
                                "hide-details": "",
                                "item-value": "key",
                                "item-title": "text",
                                width: "30px",
                                prefix: "Trier par",
                                "return-object": "",
                                density: "compact"
                              }, null, 8, ["modelValue", "items"]),
                              _createVNode(_component_v_select, {
                                modelValue: _ctx.pagination.rowsPerPage,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.pagination.rowsPerPage) = $event)),
                                items: [5, 10, 25],
                                "hide-details": "",
                                outlined: "",
                                style: {"font-size":"0.75rem","width":"min-content"},
                                width: "30px",
                                prefix: "Lignes par page",
                                density: "compact"
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("span", _hoisted_5, _toDisplayString((_ctx.pagination.page - 1) * _ctx.pagination.rowsPerPage + 1) + " - " + _toDisplayString((_ctx.pagination.page - 1) * _ctx.pagination.rowsPerPage +
                                            _ctx.pagination.rowsPerPage) + " de " + _toDisplayString(_ctx.pagination.totalItems), 1),
                              _createVNode(_component_v_btn_icon, {
                                icon: "$keyboard_arrow_left",
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.pagination.page--)),
                                disabled: _ctx.pagination.page === 1,
                                size: "small"
                              }, null, 8, ["disabled"]),
                              _createVNode(_component_v_btn_icon, {
                                icon: "$keyboard_arrow_right",
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.pagination.page++)),
                                disabled: _ctx.nextPageDisabled,
                                size: "small"
                              }, null, 8, ["disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_4)
                  ])
                ]),
                "no-data": _withCtx(() => _cache[17] || (_cache[17] = [
                  _createTextVNode("Aucune écriture trouvée")
                ])),
                item: _withCtx((props) => [
                  _createElementVNode("tr", {
                    style: {"cursor":"pointer"},
                    "data-cy": "accountingLines",
                    onClick: ($event: any) => (props.item.openDocument())
                  }, [
                    _createElementVNode("td", _hoisted_7, [
                      _createVNode(_component_v_checkbox, {
                        onClick: _withModifiers(($event: any) => (_ctx.addSelectedItem(props.item.id)), ["stop"]),
                        class: "pa-0 ma-0",
                        "hide-details": "",
                        ripple: false,
                        "model-value": _ctx.isSelected(props.item.id)
                      }, null, 8, ["onClick", "model-value"])
                    ]),
                    (_ctx.documentType === 'ALL')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                          _createElementVNode("b", null, _toDisplayString(props.item.objectType), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.formatDate(props.item.date)), 1),
                    _createElementVNode("td", _hoisted_10, [
                      _createElementVNode("strong", null, _toDisplayString(props.item.accountableAccountNameTitle), 1),
                      _createTextVNode(" " + _toDisplayString(props.item.accountableAccountDescTitle), 1)
                    ]),
                    _createElementVNode("td", null, [
                      (props.item.tag)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 0,
                            label: "",
                            color: "tagFree",
                            class: "text mr-1",
                            size: "x-small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(props.item.tag.name), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true),
                      (props.item.tags)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(props.item.tags, (tag, tagIndex) => {
                            return (_openBlock(), _createBlock(_component_v_chip, {
                              label: "",
                              class: "text mr-1",
                              key: tagIndex,
                              size: "x-small"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  style: _normalizeStyle('color:' + _ctx.labelTextColor + ';')
                                }, _toDisplayString(tag.name), 5)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(props.item.wording), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(props.item.invoiceNumber || ""), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(props.item.thirdPartyTitle), 1),
                    _createElementVNode("td", _hoisted_12, [
                      (props.item.amountSigned > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.newCommonFormatCurrency(
                                    Math.abs(props.item.amountSigned),
                                    undefined,
                                )), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_14, [
                      (props.item.amountSigned < 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.newCommonFormatCurrency(
                                    Math.abs(props.item.amountSigned),
                                    undefined,
                                )), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_6)
                ]),
                _: 1
              }, 8, ["headers", "items", "page", "sort-by", "sort-desc", "items-per-page", "items-length", "loading", "style"]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}